import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import {Provider} from 'react-redux';
import {store} from './store/store';
import ThemeContext from "./context/ThemeContext";

// Chart.js component registration (fixes missing LinearScaleBase and charts failing on load)
import {
  Chart as ChartJS,
  ArcElement,
  LineElement,
  BarElement,
  PointElement,
  CategoryScale,
  LinearScale,
  RadialLinearScale,
  DoughnutController,
  LineController,
  BarController,
  PieController,
  RadarController,
  PolarAreaController,
  Tooltip,
  Legend,
  Title,
  Filler,
} from 'chart.js';

ChartJS.register(
  ArcElement,
  LineElement,
  BarElement,
  PointElement,
  CategoryScale,
  LinearScale,
  RadialLinearScale,
  DoughnutController,
  LineController,
  BarController,
  PieController,
  RadarController,
  PolarAreaController,
  Tooltip,
  Legend,
  Title,
  Filler,
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store = {store}>
      <BrowserRouter basename='/'>
        <ThemeContext>
          <App />
        </ThemeContext>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);
reportWebVitals();